import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { inject } from "@angular/core";
import { ApiService } from "../services/api.service";

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const apiService = inject(ApiService);
  const authToken = apiService.getUserToken();
  const isRenew = req.url?.includes("renew");

  let headers: any = {};

  if (authToken?.access_token) {
    headers["Authorization"] = `Bearer ${authToken?.access_token}`;
  }

  if (isRenew && authToken?.refresh_token) {
    headers["refresh-token"] = authToken?.refresh_token;
  }

  if (Object.keys(headers).length > 0) {
    const request = req.clone({ setHeaders: headers });
    return next(request);
  }

  return next(req);
};
